import "@/App.css";
import "./print.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./lib/auth";
import { CartProvider } from "./lib/cart";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import Stores from "./pages/Stores";
import StoreDetail from "./pages/StoreDetail";
import Cart from "./pages/Cart";
import Checkout from "./pages/Checkout";
import PaymentReturn from "./pages/PaymentReturn";
import MyOrders from "./pages/MyOrders";
import OrderDetail from "./pages/OrderDetail";
import Track from "./pages/Track";
import Dashboard from "./pages/Dashboard";
import BecomeSeller from "./pages/BecomeSeller";
import SearchResults from "./pages/SearchResults";
import Compare from "./pages/Compare";
import NewTender from "./pages/NewTender";
import Tenders from "./pages/Tenders";
import Profile from "./pages/Profile";
import MyCoins from "./pages/MyCoins";
import Admin from "./pages/Admin";
import PincodeStores from "./pages/PincodeStores";
import MyPriceAlerts from "./pages/MyPriceAlerts";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import RefundPolicy from "./pages/RefundPolicy";
import ShippingPolicy from "./pages/ShippingPolicy";
import Contact from "./pages/Contact";
import EmergencyHistory from "./pages/EmergencyHistory";
import SupplyChain from "./pages/SupplyChain";
import FactoryProfile from "./pages/FactoryProfile";
import Fleet from "./pages/Fleet";
import AiBuy from "./pages/AiBuy";
import PartnerRegister from "./pages/PartnerRegister";
import Catalog from "./pages/Catalog";
import CatalogProduct from "./pages/CatalogProduct";
import Directory from "./pages/Directory";
import Storefront from "./pages/Storefront";
import IndiaCheckout from "./pages/IndiaCheckout";
import Wishlist from "./pages/Wishlist";
import Categories from "./pages/Categories";
import MyKhata from "./pages/MyKhata";
import PoVerify from "./pages/PoVerify";
import BusinessLayout from "./pages/business/BusinessLayout";
import BusinessDashboard from "./pages/business/BusinessDashboard";
import DayBook from "./pages/business/DayBook";
import Complaints from "./pages/business/Complaints";
import ComplaintDetail from "./pages/business/ComplaintDetail";
import Customers, { CustomerDetail } from "./pages/business/Customers";
import Followups from "./pages/business/Followups";
import DayClose from "./pages/business/DayClose";
import BusinessSettings from "./pages/business/BusinessSettings";
import ReviewReminderBanner from "./components/ReviewReminderBanner";
import RouteTracker from "./components/RouteTracker";
import ChatWidget from "./components/ChatWidget";
import { I18nProvider } from "./lib/i18n";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <I18nProvider>
          <AuthProvider>
            <CartProvider>
              <Layout>
              <RouteTracker />
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/stores" element={<Stores />} />
                <Route path="/stores/:id" element={<StoreDetail />} />
                <Route path="/cart" element={<Cart />} />
                <Route path="/checkout" element={<Checkout />} />
                <Route path="/payment-return" element={<PaymentReturn />} />
                <Route path="/orders" element={<MyOrders />} />
                <Route path="/orders/:id" element={<OrderDetail />} />
                <Route path="/track/:id" element={<Track />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/become-seller" element={<BecomeSeller />} />
                <Route path="/search" element={<SearchResults />} />
                <Route path="/compare" element={<Compare />} />
                <Route path="/tender/new" element={<NewTender />} />
                <Route path="/tenders" element={<Tenders />} />
                <Route path="/profile" element={<Profile />} />
                <Route path="/coins" element={<MyCoins />} />
                <Route path="/price-alerts" element={<MyPriceAlerts />} />
                <Route path="/terms" element={<Terms />} />
                <Route path="/privacy" element={<Privacy />} />
                <Route path="/refund-policy" element={<RefundPolicy />} />
                <Route path="/shipping-policy" element={<ShippingPolicy />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/admin" element={<Admin />} />
                <Route path="/pincode/:pin" element={<PincodeStores />} />
                <Route path="/emergency/history" element={<EmergencyHistory />} />
                <Route path="/supply-chain" element={<SupplyChain />} />
                <Route path="/factory/:ms_id" element={<FactoryProfile />} />
                <Route path="/fleet" element={<Fleet />} />
                <Route path="/ai-buy" element={<AiBuy />} />
                <Route path="/partner/register" element={<PartnerRegister />} />
                <Route path="/catalog" element={<Catalog />} />
                <Route path="/checkout/india" element={<IndiaCheckout />} />
                <Route path="/wishlist" element={<Wishlist />} />
                <Route path="/p/:slug" element={<CatalogProduct />} />
                <Route path="/brands" element={<Directory kind="brands" />} />
                <Route path="/brands/:slug" element={<Storefront kind="brand" />} />
                <Route path="/manufacturers" element={<Directory kind="manufacturers" />} />
                <Route path="/manufacturers/:slug" element={<Storefront kind="manufacturer" />} />
                <Route path="/categories" element={<Categories />} />
                <Route path="/khata" element={<MyKhata />} />
                <Route path="/po/verify/:token" element={<PoVerify />} />
                <Route path="/business" element={<BusinessLayout />}>
                  <Route index element={<BusinessDashboard />} />
                  <Route path="daybook" element={<DayBook />} />
                  <Route path="customers" element={<Customers />} />
                  <Route path="customers/:id" element={<CustomerDetail />} />
                  <Route path="complaints" element={<Complaints />} />
                  <Route path="complaints/:no" element={<ComplaintDetail />} />
                  <Route path="followups" element={<Followups />} />
                  <Route path="day-close" element={<DayClose />} />
                  <Route path="settings" element={<BusinessSettings />} />
                </Route>
              </Routes>
              <ChatWidget />
              </Layout>
            </CartProvider>
          </AuthProvider>
        </I18nProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
